// Zustand store for NIFC AGOL auth state. Components subscribe instead of
// hitting IndexedDB directly. The store hydrates on first import via
// hydrate() (called by main.tsx) and stays in sync with the underlying
// token storage through the public sign-in/sign-out helpers.

import { create } from 'zustand';
import * as agol from '../lib/agol-auth';

interface AgolAuthState {
  /** True once we've made our first attempt to read tokens from IDB. */
  ready: boolean;
  /** True if a usable (non-expired or refreshable) session exists. */
  signedIn: boolean;
  /** ArcGIS username, when known. */
  username: string | null;
  /** True when the OAuth client ID env var has been provisioned. */
  configured: boolean;

  hydrate: () => Promise<void>;
  signOut: () => Promise<void>;
  setSignedIn: (username: string | null) => void;
}

export const useAgolAuthStore = create<AgolAuthState>((set) => ({
  ready: false,
  signedIn: false,
  username: null,
  configured: agol.isConfigured(),

  hydrate: async () => {
    const username = await agol.getCurrentUsername();
    const signedIn = await agol.isSignedIn();
    set({ ready: true, signedIn, username, configured: agol.isConfigured() });
  },

  signOut: async () => {
    await agol.signOut();
    set({ signedIn: false, username: null });
  },

  setSignedIn: (username) => set({ signedIn: !!username, username }),
}));
